<ng-container>
  <div class="js-modal__wrapper subscribe-form__news" id="subscribeEmailModal">
    <div class="subscribe-form__news-inner js-subscribe-form__wrap-inner">
      <div class="subscribe-form__news-content">
        <div class="subscribe-form__news-title">Подпишитесь на рассылку</div>
        <div class="subscribe-form__news-sub-title">Узнавайте первыми об акциях, скидках и спецпредложениях!</div>
        <div class="subscribe-form__news-checkboxes">
          <div class="subscribe-form__news-row">
            <label class="checkbox-classic js-news-check">
              <input value="newbuildings" type="checkbox" class="checkbox-classic__input js-news-checkbox">
              <span class="checkbox-classic__label">Все о Новостройках</span>
            </label>
          </div>
          <div class="subscribe-form__news-row">
            <label class="checkbox-classic js-news-check">
              <input value="secondaryhousing"  type="checkbox" class="checkbox-classic__input js-news-checkbox">
              <span class="checkbox-classic__label">Все о Вторичке</span>
            </label>
          </div>
          <div class="subscribe-form__news-row">
            <label class="checkbox-classic js-news-check">
              <input value="commercialproperty"  type="checkbox" class="checkbox-classic__input js-news-checkbox">
              <span class="checkbox-classic__label">Коммерческая недвижимость</span>
            </label>
          </div>
          <div class="subscribe-form__news-row js-checkbox-error hidden">
            <div class="subscribe-form__news-row--error">Выберите тематику email подписки</div>
          </div>
        </div>
        <div class="subscribe-form__news-form">
          <input type="text" class="input-text input-text--middle subscribe-form__news-text js-subscribe-form__input" placeholder="Введите e-mail">
          <button class="button button--middle subscribe-form__news-button js-subscribe-email__form-button">Подписаться</button>
        </div>
        <div class="subscribe-form__news-agreement">Нажимая кнопку «Подписаться», вы подтверждаете свое <a href="/agreement" target="_blank">согласие на обработку персональных данных</a></div>
      </div>
    </div>

    <div class="subscribe-form__news-success js-subscribe-form--success hidden">
      <div class="subscribe-form__news-success__title">Спасибо!</div>
      <div class="subscribe-form__news-success__sub-title">Вам на почту отправлено письмо для подтверждения адреса электронной почты</div>
      <div class="subscribe-form__news-success__button">
        <button class="button button--middle" data-fancybox-close >Вернуться на сайт</button>
      </div>
    </div>
  </div>
</ng-container>
